/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import { useEffect, useState } from "react";
import CustomCheckbox from "components/CustomCheckbox/CustomCheckbox";
import Author from "components/Table/Author";
import { useSelector } from "react-redux";
import { Common } from "utils/Constants";

export default function RoleData({ handleChange }) {
  const [rows, setRows] = useState([]);
  const roleAggrementData = useSelector((state) => state.roleAgreement?.list);

  const getPermissionName = (name) => {
    switch (name) {
      case Common.ORDER_APPROVAL:
        return Common.PROJECT_ORDERS;
      case Common.REQUEST_LABLE:
        return Common.PROJECT_EQUIPMENT_REQUEST;
      default:
        return name;
    }
  };
  useEffect(() => {
    if (roleAggrementData) {
      // Identify Personnel & Personnel Basic items
      const personnelBasic = roleAggrementData.find(
        (item) => item.accountLicence.permission[0].name === Common.PESONNEL_BASIC
      );
      const personnel = roleAggrementData.find(
        (item) => item.accountLicence.permission[0].name === Common.PERSONNEL
      );

      // Determine conditions
      const isPersonnelBasicRead = personnelBasic?.agreement?.read;
      const isAnyPersonnelPermission =
        personnel?.agreement?.read ||
        personnel?.agreement?.create ||
        personnel?.agreement?.update ||
        personnel?.agreement?.delete;

      const tempRows = roleAggrementData?.map((element, index) => {
        const permissionName = getPermissionName(element?.accountLicence?.permission[0].name);
        const agreement = element?.agreement;

        const isPersonnel = permissionName === Common.PERSONNEL;
        const isPersonnelBasic = permissionName === Common.PESONNEL_BASIC;

        const disablePersonnelFields = isPersonnel && isPersonnelBasicRead;
        const disablePersonnelBasicRead = isPersonnelBasic && isAnyPersonnelPermission;

        const temp = {
          srNo: <Author name={index + 1} />,
          module: <Author name={permissionName} />,

          read: (
            <CustomCheckbox
              name="read"
              checked={agreement?.read}
              disabled={disablePersonnelFields || disablePersonnelBasicRead}
              onChange={(e) => handleChange("read", e, element)}
            />
          ),

          write: (
            <CustomCheckbox
              name="create"
              checked={agreement?.create}
              disabled={isPersonnelBasic || disablePersonnelFields}
              onChange={(e) => handleChange("create", e, element)}
            />
          ),

          update: (
            <CustomCheckbox
              name="update"
              checked={agreement?.update}
              disabled={isPersonnelBasic || disablePersonnelFields}
              onChange={(e) => handleChange("update", e, element)}
            />
          ),

          delete: (
            <CustomCheckbox
              name="delete"
              checked={agreement?.delete}
              disabled={isPersonnelBasic || disablePersonnelFields}
              onChange={(e) => handleChange("delete", e, element)}
            />
          ),

          action: (
            <CustomCheckbox
              name="checkAllRowBox"
              checked={
                agreement?.read && agreement?.create && agreement?.update && agreement?.delete
              }
              disabled={isPersonnelBasic || disablePersonnelFields}
              onChange={(e) => handleChange("checkAllRowBox", e, element)}
            />
          ),
        };

        return temp;
      });

      setRows([...tempRows]);
    }
  }, [roleAggrementData]);

  return {
    columns: [
      { Header: "No.", accessor: "srNo", width: "3%", align: "center" },
      { Header: "Module", accessor: "module", width: "30%", align: "left" },
      {
        Header: "Read",
        accessor: "read",
        align: "center",
      },
      {
        Header: "Write",
        accessor: "write",
        align: "center",
      },
      {
        Header: "Update",
        accessor: "update",
        align: "center",
      },
      {
        Header: "Delete",
        accessor: "delete",
        align: "center",
      },
      {
        Header: "Check All",
        accessor: "action",
        align: "center",
      },
    ],
    rows,
  };
}
